export default {
    'diagram3b1-7': {
        'checkboxes': {
            'title': 'Question:	',
            'checkbox-1': 'Why was it?',
            'checkbox-2': 'How was it?',
            'checkbox-3': 'How do you know it was?',
        },
        'elements': {
            'one': 'The fall of Lehman was the most destabilizing financial event since the bank runs of the 1930s Depression',
            'two': 'Corporate bond spreads widened twice as much as after the 1929 crash',
            'three': 'The Fed had to quadruple its foreign exchange swaps',
            'four': 'The credit-backed securities market virtually vanished overnight',
            'five': 'Businesses quickly began downsizing staff and reining in investments'
        },
        'checkboxes-bottom': {
            'title': 'General Plural Noun',
            'checkbox-1': 'Reasons',
            'checkbox-2': 'Steps',
            'checkbox-3': 'Proofs',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b1/diagram7/i18n/en.js